<div fxLayout="column">
  <button *ngFor="let Outlet of outlets | async" mat-button (click)="login(Outlet)">{{Outlet}}</button>
  <mat-icon class="erro" color="warn" aria-hidden="false" *ngIf="(outlets | async)?.length==0"
    aria-label="Oops Something happend!">error_outline</mat-icon>
  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
</div>